module.exports = __webpack_public_path__ + "public/img/link_sent.24fa9807.png";